'use client';

import React from 'react';
import styled, { useTheme } from 'styled-components';

export interface MonoValueProps {
  value: string | number;
  unit?: string;
  label?: string;
  muted?: boolean;
  className?: string;
}

const Wrapper = styled.span<{ $muted?: boolean }>`
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  font-size: ${(p) => p.theme.fontSize.sm};
  font-weight: ${(p) => p.theme.fontWeight.bold};
  color: ${(p) => (p.$muted ? p.theme.colors.neutral.inkSoft : p.theme.colors.neutral.ink)};
  line-height: 1;
`;

const Unit = styled.span`
  font-weight: ${(p) => p.theme.fontWeight.medium};
  color: ${(p) => p.theme.colors.neutral.inkMute};
  font-size: ${(p) => p.theme.fontSize.xs};
`;

export function MonoValue({ value, unit, label, muted, className }: MonoValueProps) {
  const theme = useTheme() as any;
  const ariaLabel = label ? `${label}: ${value}${unit ? ` ${unit}` : ''}` : undefined;
  return (
    <Wrapper
      $muted={muted}
      aria-label={ariaLabel}
      className={className}
      style={{ fontFamily: theme.fontFamily.mono }}
    >
      {value}
      {unit && <Unit>{unit}</Unit>}
    </Wrapper>
  );
}
